"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _useToggle = _interopRequireDefault(require("react-use/lib/useToggle"));
var _Dropdown = require("./Dropdown");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const DropdownContainer = _ref => {
  let {
    isHoverable,
    ...originalProps
  } = _ref;
  const {
    hasTogglerWidth
  } = originalProps;
  const [isMenuVisible, setIsMenuVisible] = (0, _useToggle.default)(false);
  const dropdownTogglerRef = (0, _react.useRef)(null);
  const dropdownMenuRef = (0, _react.useRef)(null);
  const menuPositionInitialValue = {
    left: null,
    arrowLeft: null,
    width: null
  };
  const [menuPositionConfig, setMenuPositionConfig] = (0, _react.useState)(menuPositionInitialValue);
  const [hasPositionCalculated, setHasPositionCalculated] = (0, _react.useState)(false);
  const handleMouseEnter = () => {
    if (isHoverable) {
      setIsMenuVisible(true);
    }
  };
  const handleMouseLeave = () => {
    if (isHoverable) {
      setIsMenuVisible(false);
      setMenuPositionConfig(menuPositionInitialValue);
      setHasPositionCalculated(false);
    }
  };
  const handleOnClick = () => {
    setIsMenuVisible();
    if (hasPositionCalculated) {
      setHasPositionCalculated(false);
      setMenuPositionConfig(menuPositionInitialValue);
    }
  };
  (0, _react.useEffect)(() => {
    if (isMenuVisible && dropdownTogglerRef.current && dropdownMenuRef.current) {
      const {
        left: togglerLeft,
        right: togglerRight,
        width: togglerWidth
      } = dropdownTogglerRef.current.getBoundingClientRect();
      const {
        width: menuWidth
      } = dropdownMenuRef.current.getBoundingClientRect();
      const containersWidthDifference = menuWidth - togglerWidth;
      const offset = containersWidthDifference / 2;
      let left = null;
      let arrowLeft = null;
      let width = null;
      switch (true) {
        case hasTogglerWidth:
          break;
        case togglerWidth > menuWidth:
          left = (togglerWidth - menuWidth) / 2;
          break;
        case togglerRight + offset > window.innerWidth:
          {
            left = -containersWidthDifference;
            arrowLeft = containersWidthDifference;
            break;
          }
        case togglerLeft - offset > 0:
          {
            left = -offset;
            break;
          }
        default:
          {
            arrowLeft = -containersWidthDifference;
            break;
          }
      }
      if (hasTogglerWidth) {
        width = togglerWidth;
      }
      setMenuPositionConfig({
        left,
        arrowLeft,
        width
      });
      setHasPositionCalculated(true);
    }
  }, [hasTogglerWidth, isMenuVisible]);
  return /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, (0, _extends2.default)({}, originalProps, {
    isMenuVisible: isMenuVisible,
    onClick: handleOnClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    dropdownTogglerRef: dropdownTogglerRef,
    dropdownMenuRef: dropdownMenuRef,
    menuPositionConfig: menuPositionConfig,
    hasPositionCalculated: hasPositionCalculated
  }));
};
exports.DropdownContainer = DropdownContainer;
//# sourceMappingURL=DropdownContainer.js.map